// Sprint 4 (kamers): teksten voor kamers met bewoners, de schoonmaakkast, het kindslot, voorlezen
// en spraakinvoer (docs/DESIGN.md 8.K12–K14, 8.W23–W25). Je-vorm, korte zinnen, werkwoorden op
// knoppen. Meervoud via { one, other } (t()).
export const kamersNl = {
    nav: {
        rooms: 'Kamers',
        cleaning: 'Schoonmaak',
        kidLock: 'Kindslot',
    },
    roomKind: {
        living: 'Woonkamer',
        bedroom: 'Slaapkamer',
        utility: 'Washok of kast',
    },
    rooms: {
        title: 'Kamers',
        intro: 'Elke tablet hoort bij een kamer. Een kamer bepaalt wie je op de tablet ziet.',
        add: 'Kamer',
        addTitle: 'Nieuwe kamer',
        everyone: 'Iedereen',
        tablets: { one: '{count} tablet', other: '{count} tablets' },
        noTablet: 'Nog geen tablet',
        modeAgenda: 'Agenda en taken',
        modeLogboek: 'Schoonmaakkast',
        open: 'Openen',
        back: 'Kamers',
        name: 'Naam',
        nameHint: 'Bijvoorbeeld: Kamer van Sem en Daan',
        kind: 'Soort kamer',
        whoTitle: 'Wie zie je op deze tablet?',
        whoIntro: 'Op een slaapkamertablet zie je alleen de mensen die er slapen.',
        whoAll: 'Iedereen',
        whoExplicit: 'Alleen bewoners',
        residents: 'Bewoners',
        residentsHint: 'Tik op een gezicht om het aan of uit te zetten.',
        noResidentsWarning: 'Kies wie hier slaapt, anders blijft de tablet leeg.',
        noResidentsUtility: 'Zonder bewoners kan iedereen zichzelf kiezen op deze tablet.',
        householdWide: 'Ook afspraken voor het hele gezin tonen',
        showTitle: 'Wat toont de tablet?',
        showAgenda: 'Agenda en taken',
        showAgendaHint: 'Het gewone bord met vandaag, de week en de taken.',
        showLogboek: 'Schoonmaakkast',
        showLogboekHint: 'Grote tegels: wie heeft de was gedaan, wie stofzuigde.',
        a11yTitle: 'Toegankelijkheid op de tablet',
        readAloud: 'Voorlezen',
        readAloudHint: 'Tik op een plaatje en de tablet leest het voor. Handig voor wie nog niet leest.',
        textSize: 'Tekstgrootte',
        textNormal: 'Normaal',
        textLarge: 'Groot',
        textFar: 'Heel groot',
        calmMotion: 'Rustige beweging',
        calmMotionHint: 'Geen bewegende vieringen, alles verschijnt stil.',
        sounds: 'Geluid',
        tabletsTitle: 'Tablets in deze kamer',
        tabletsEmpty: 'Hier hangt nog geen tablet.',
        moveHere: 'Tablet hierheen verplaatsen',
        moveChoose: 'Kies een tablet',
        moved: '{name} hangt nu in {room}.',
        lastSeen: 'laatst gezien {ago}',
        save: 'Opslaan',
        saved: 'Opgeslagen. De tablet toont het binnen een minuut.',
        created: '{name} is toegevoegd.',
        remove: 'Kamer verwijderen',
        removeBlocked: 'Verplaats eerst de tablet naar een andere kamer.',
        removeTitle: 'Kamer verwijderen?',
        removeBody: '{name} verdwijnt. De historie blijft bewaard.',
        removeConfirm: 'Verwijderen',
        removed: '{name} is verwijderd.',
        lastRoom: 'Een huishouden houdt minstens één kamer.',
        conflict: 'Deze kamer is intussen door iemand anders gewijzigd. We hebben de nieuwste versie geladen.',
        emptyTitle: 'Elke kamer een eigen bord',
        emptyBody: 'Hang een tablet in de slaapkamer of het washok en kies wie je daar ziet.',
        notFound: 'Deze kamer bestaat niet (meer).',
    },
    cleaning: {
        title: 'Schoonmaak',
        add: 'Klus',
        tabTurn: 'Aan de beurt',
        tabHistory: 'Historie',
        tabItems: 'Klussen',
        turnIntro: 'Wie een klus het langst niet deed, is aan de beurt.',
        status: { fresh: 'Net gedaan', soon: 'Bijna', due: 'Mag weer' },
        every: { one: 'elke dag', other: 'elke {count} dagen' },
        everyWeek: 'elke week',
        every2Weeks: 'elke 2 weken',
        everyMonth: 'elke maand',
        lastBy: 'Laatst: {name}, {when}',
        never: 'Nog nooit gedaan',
        turn: 'Aan de beurt',
        doneAction: 'Gedaan…',
        doneTitle: '{item} gedaan',
        who: 'Wie',
        when: 'Wanneer',
        time: 'Tijd',
        whenHint: 'Terugzetten kan tot 30 dagen.',
        note: 'Notitie',
        logged: '{item}: gedaan door {name}.',
        loggedNoPoints: 'Opgeslagen. Geen punten: {name} deed het al op {when}.',
        points: { one: '{count} ster', other: '{count} sterren' },
        alreadyBy: 'al gedaan door {name}',
        deleted: 'verwijderd',
        source: { kiosk: 'op de tablet', app: 'in de app' },
        removeLog: 'Verwijderen',
        removeLogTitle: 'Deze keer verwijderen?',
        removeLogBody: '{name} krijgt de punten niet meer.',
        removeLogConfirm: 'Verwijderen',
        logRemoved: 'Verwijderd.',
        negativeTitle: 'Saldo wordt negatief',
        negativeBody: '{name} heeft de punten al uitgegeven. Toch verwijderen?',
        historyEmptyTitle: 'Nog niets gedaan',
        historyEmptyBody: 'Zodra iemand iets logt, zie je het hier.',
        filterAll: 'Iedereen',
        filterLabel: 'Filter op lid',
        showDeleted: 'Ook verwijderde tonen',
        today: 'Vandaag',
        yesterday: 'Gisteren',
        itemsIntro: 'Per plek de klussen en hoe vaak ze terugkomen.',
        noLocation: 'Zonder plek',
        edit: 'Bewerken',
        archive: 'Weghalen',
        archived: '{name} is weggehaald.',
        editorNew: 'Nieuwe klus',
        editorEdit: 'Klus bewerken',
        itemName: 'Naam',
        itemNameHint: 'Kort en duidelijk, bijvoorbeeld: Wasmachine aanzetten',
        icon: 'Pictogram',
        location: 'Plek',
        newLocation: 'Nieuwe plek…',
        newLocationName: 'Naam van de plek',
        howOften: 'Hoe vaak',
        customDays: 'Aantal dagen',
        pointsLabel: 'Punten',
        pointsHint: 'Hooguit één keer per periode, ook als meer mensen het doen.',
        participants: 'Wie doet mee',
        participantsHint: 'Niemand gekozen = iedereen.',
        saved: 'Opgeslagen.',
        conflict: 'Deze klus is intussen gewijzigd. We hebben de nieuwste versie geladen.',
        emptyTitle: 'Nog geen schoonmaakklussen',
        emptyBody: 'Begin met iets dat vaak terugkomt, zoals de wasmachine.',
        emptyAction: 'Klus toevoegen',
        suggestions: 'Of begin met een voorbeeld',
        suggest: {
            laundry: 'Wasmachine aanzetten',
            hang: 'Was ophangen',
            bath: 'Badkamer poetsen',
            vacuum: 'Stofzuigen',
            plants: 'Planten water geven',
        },
        loadError: 'Er ging iets mis. Probeer het opnieuw.',
        retry: 'Opnieuw proberen',
    },
    kidLock: {
        title: 'Kindslot',
        intro: 'Handig als broertjes of zusjes elkaars taken afvinken. Standaard uit; het slot geldt alleen op de tablet.',
        none: 'Geen slot',
        pin: 'Pincode',
        picture: 'Plaatjescode',
        since: 'sinds {when}',
        waiting: 'wacht tot {time}',
        set: 'Instellen',
        change: 'Wijzigen',
        sheetTitle: 'Kindslot voor {name}',
        kindLabel: 'Soort slot',
        noneHint: 'Iedereen kan op de tablet voor {name} tikken.',
        pinHint: '4 cijfers die {name} onthoudt.',
        pictureHint: '4 plaatjes op volgorde. Laat {name} ze zelf kiezen.',
        pinLabel: 'Pincode (4 cijfers)',
        pinRepeat: 'Nog een keer',
        pinMismatch: 'De twee pincodes zijn niet gelijk.',
        pinInvalid: 'Kies precies 4 cijfers.',
        pictureChosen: 'Gekozen: {count} van 4',
        pictureClear: 'Wissen',
        pictureInvalid: 'Kies 4 plaatjes.',
        pictureSlot: 'Plaatje {n}',
        saved: 'Het kindslot van {name} is aangepast.',
        removed: 'Het kindslot van {name} staat uit.',
        emptyTitle: 'Nog geen kinderen',
        emptyBody: 'Voeg eerst je kinderen toe bij Leden.',
        about: 'Vergeten? Stel hier een nieuwe code in. Vijf keer fout op de tablet betekent even wachten.',
    },
    picture: {
        fox: 'Vos',
        cat: 'Kat',
        rabbit: 'Konijn',
        bear: 'Beer',
        panda: 'Panda',
        owl: 'Uil',
        lion: 'Leeuw',
        frog: 'Kikker',
        turtle: 'Schildpad',
    },
    voice: {
        dictate: 'Inspreken',
        listening: 'Ik luister…',
        stop: 'Stoppen',
        heard: 'Gehoord: {text}',
        failed: 'Dat verstond ik niet. Typ het maar.',
    },
    kiosk: {
        entry: 'Schoonmaken',
        title: 'Schoonmaakkast',
        back: 'Terug',
        who: 'Wie heeft het gedaan?',
        hold: 'Houd je gezicht vast tot de cirkel vol is',
        holdShort: 'Houd vast',
        status: { fresh: 'Net gedaan', soon: 'Bijna', due: 'Mag weer' },
        never: 'nog nooit',
        justNow: 'net',
        minutesAgo: { one: '{count} min', other: '{count} min' },
        hoursAgo: { one: '{count} uur', other: '{count} uur' },
        daysAgo: { one: '1 dag', other: '{count} dagen' },
        goodJob: 'Goed gedaan, {name}!',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: 'Gedaan door {name}',
        stars: { one: '+{count} ster', other: '+{count} sterren' },
        alreadyDone: 'Al gedaan door {name} om {time}. Toch bedankt!',
        alreadyDoneCalm: 'Al gedaan door {name} om {time}.',
        oops: 'Oeps',
        undone: 'Weer weggehaald',
        other: 'Anders…',
        otherTitle: 'Wat heb je gedaan?',
        sayIt: 'Zeg het maar',
        emptyTitle: 'Nog geen klusjes',
        emptyBody: 'Papa of mama zet ze klaar in de app.',
        notSaved: 'Nog niet opgeslagen, we proberen het zo weer.',
        close: 'Sluiten',
        lockAskPin: '{name}, wat is je code?',
        lockAskPicture: '{name}, welke plaatjes?',
        lockWrong: 'Nog een keer',
        lockWait: 'Even wachten…',
        lockDigit: 'Cijfer {digit}',
        lockErase: 'Wissen',
        lockProgress: '{count} van 4',
        adhoc: {
            windows: 'Ramen zemen',
            sweep: 'Vegen',
            trash: 'Afval wegbrengen',
            dishes: 'Afwassen',
            'tidy-up': 'Opruimen',
            'water-plants': 'Planten water',
            recycling: 'Glas en papier',
            'make-bed': 'Bed verschonen',
        },
    },
    speech: {
        at: 'om {time}',
        points: { one: '{count} ster', other: '{count} sterren' },
    },
    a11y: {
        skipToContent: 'Naar de inhoud',
        mainNav: 'Hoofdnavigatie',
    },
};
//# sourceMappingURL=kamers.nl.js.map